/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type CallType = (typeof CallType)[keyof typeof CallType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CallType = {
  PHONE: 'PHONE',
  WEB: 'WEB',
} as const;
